<div id="navigation-bar" class="navbar">
  <mat-toolbar>
    <mat-toolbar-row>
      <div class="navbar-row">

        <div class="navbar-col show-mobile">
          <button mat-icon-button (click)="toggleSideNav()">
            <mat-icon svgIcon="navigation:ic_menu_24px"></mat-icon>
          </button>
        </div>

        <div class="navbar-col">
          <h1 class="title">Control Panel</h1>
        </div>

        <div class="navbar-spacer"></div>

        <div class="navbar-col balance-btn">
          <app-payment-btn placement="desktop"></app-payment-btn>
        </div>

        <div class="navbar-col">
          <mat-menu #userMenu="matMenu">
            <button mat-menu-item disabled>{{ 'BUTTONS.SETINGS' | translate }}</button>
            <button mat-menu-item (click)="logout()">{{ 'BUTTONS.LOGOUT' | translate }}</button>
          </mat-menu>

          <button mat-button [matMenuTriggerFor]="userMenu">
            <mat-icon svgIcon="action:ic_account_circle_24px"></mat-icon>
            <span class="email">{{ email }}</span>
            <mat-icon svgIcon="navigation:ic_expand_more_24px"></mat-icon>
          </button>
        </div>

        <div class="navbar-col">
          <app-language-switcher></app-language-switcher>
        </div>

      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-progress-bar class="global-loader" mode="indeterminate" *ngIf="(showLoader | async) > 0" color="warn"
  ></mat-progress-bar>

</div>
